import { WorkflowDetailsOverview } from "@/pages/workflow-details/ui/workflow-details-overview";
import { createFileRoute } from "@tanstack/react-router";

const WorkflowDetailsRoute = () => {
  return <WorkflowDetailsOverview />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/workflows/$workflowId/",
)({
  component: WorkflowDetailsRoute,
});
